// Single place for the booking endpoints. Replace the placeholders with the
// real StaffAble values before going live.
//
// WHATSAPP_NUMBER: international format, digits only, no plus sign.
//   e.g. India number +91 99999 99999  ->  "919999999999"
export const WHATSAPP_NUMBER = "919970813971";

// Cal.com booking. CAL_LINK is the public event path used by the inline embed
// (the calendar opens inside our own page, no redirect). CAL_URL is the same
// link as a plain URL fallback. The secret API key is intentionally NOT here:
// this is a public static bundle, so a server-only key would be exposed.
export const CAL_LINK = "staffable-ai001-dg3qnx/30min";
export const CAL_URL = `https://cal.com/${CAL_LINK}`;

// The words sent into the WhatsApp chat when an owner books.
export function whatsappLink(opts?: { name?: string; business?: string }) {
  const lines = [
    "Hi StaffAble, I want a free call about AI Employees for my business.",
  ];
  if (opts?.name) lines.push(`Name: ${opts.name}`);
  if (opts?.business) lines.push(`Business: ${opts.business}`);
  const text = encodeURIComponent(lines.join("\n"));
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
}
